import { render, staticRenderFns } from "./CreditNoteAttachmentButton.vue?vue&type=template&id=64c72999"
import script from "./CreditNoteAttachmentButton.vue?vue&type=script&lang=js"
export * from "./CreditNoteAttachmentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports